<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import QRBuhoCampaignForm from './QRBuhoCampaignForm.vue';

const props = defineProps({
  mode: {
    type: String,
    default: 'create',
  },
  campaign: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const isEditMode = computed(
  () => props.mode === 'edit' && !!props.campaign?.id
);
const isCloneMode = computed(
  () => props.mode === 'clone' && !!props.campaign?.id
);

const dialogTitle = computed(() => {
  if (isEditMode.value) {
    return t('CAMPAIGN.QRBUHO.EDIT.TITLE');
  }

  if (isCloneMode.value) {
    return t('CAMPAIGN.QRBUHO.CLONE.TITLE');
  }

  return t('CAMPAIGN.QRBUHO.CREATE.TITLE');
});

const handleSubmit = async formData => {
  try {
    if (isEditMode.value) {
      await store.dispatch('campaigns/update', {
        id: props.campaign.id,
        data: formData,
      });
      useAlert(t('CAMPAIGN.QRBUHO.EDIT.FORM.API.SUCCESS_MESSAGE'));
    } else {
      await store.dispatch('campaigns/create', formData);
      useAlert(
        t(
          isCloneMode.value
            ? 'CAMPAIGN.QRBUHO.CLONE.FORM.API.SUCCESS_MESSAGE'
            : 'CAMPAIGN.QRBUHO.CREATE.FORM.API.SUCCESS_MESSAGE'
        )
      );
    }

    emit('close');
  } catch (error) {
    useAlert(t('CAMPAIGN.QRBUHO.CREATE.FORM.API.ERROR_MESSAGE'), 'error');
  }
};

const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[25rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-md max-h-[80vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-6">
      <h3 class="text-base font-medium text-n-slate-12 flex-shrink-0">
        {{ dialogTitle }}
      </h3>
      <QRBuhoCampaignForm
        :mode="mode"
        :campaign="campaign"
        @submit="handleSubmit"
        @cancel="handleClose"
      />
    </div>
  </div>
</template>
